import request from '../utils/request';

// Excel导入用户
export const importUsers = (formData) => {
  return request.post('/admin/users/import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

// 获取用户列表
export const getUserList = (params) => {
  return request.get('/admin/users', { params });
};

// 添加用户
export const addUser = (data) => {
  return request.post('/admin/users', data);
};

// 重置用户密码
export const resetPassword = (id) => {
  return request.post(`/admin/users/${id}/reset-password`);
};

// 修改用户资料
export const updateUser = (id, data) => {
  return request.put(`/admin/users/${id}`, data);
};

// 获取部门列表
export const getDepartments = () => {
  return request.get('/admin/departments');
};

// 添加部门
export const addDepartment = (data) => {
  return request.post('/admin/departments', data);
};

// 删除部门
export const deleteDepartment = (id) => {
  return request.delete(`/admin/departments/${id}`);
};

// 修改部门
export const updateDepartment = (id, data) => {
  return request.put(`/admin/departments/${id}`, data);
};

// 更新行为准则内容
export const updateContent = (id, data) => {
  return request.put(`/admin/contents/${id}`, data);
};

// 上传音频文件
export const uploadAudio = (formData) => {
  return request.post('/admin/contents/upload-audio', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

// 获取题目列表
export const getQuestions = (params) => {
  return request.get('/admin/questions', { params });
};

// 添加题目
export const addQuestion = (data) => {
  return request.post('/admin/questions', data);
};

// 更新题目
export const updateQuestion = (id, data) => {
  return request.put(`/admin/questions/${id}`, data);
};

// 删除题目
export const deleteQuestion = (id) => {
  return request.delete(`/admin/questions/${id}`);
};

// 获取完形填空列表
export const getFillBlanks = (params) => {
  return request.get('/admin/fillblanks', { params });
};

// 添加完形填空
export const addFillBlank = (data) => {
  return request.post('/admin/fillblanks', data);
};

// 更新完形填空
export const updateFillBlank = (id, data) => {
  return request.put(`/admin/fillblanks/${id}`, data);
};

// 删除完形填空
export const deleteFillBlank = (id) => {
  return request.delete(`/admin/fillblanks/${id}`);
};

// 获取统计数据
export const getStatistics = () => {
  return request.get('/admin/statistics');
};

// 修改用户密码（管理员操作）
export const changeUserPassword = (id, data) => {
  return request.put(`/admin/users/${id}/password`, data);
};

// 获取登录日志
export const getLoginLogs = (params) => {
  return request.get('/admin/login-logs', { params });
};

// 获取承诺列表
export const getPromises = (params) => {
  return request.get('/admin/promises', { params });
};

// 管理员修改自己的密码
export const changeAdminPassword = (data) => {
  return request.put('/admin/profile/password', data);
};

// 导出报表
export const exportData = (type) => {
  return request.get('/admin/export', {
    params: { type },
    responseType: 'blob'
  });
};

// 导出学习数据
export const exportLearningData = (fields) => {
  return request.get('/admin/export-data', {
    params: { fields }
  });
};
